import React from "react";
import { cn } from "utils";
import { HORIZONTAL_SCROLL_ATTR } from "@/src/hooks/useSwipeTabs";

interface IndicesListSkeletonProps {
  /** 骨架屏数量，默认 4 个 */
  count?: number;
  /** 额外类名 */
  className?: string;
}

/**
 * IndicesList 骨架屏组件
 * 用于保持布局稳定，避免路由切换时的抖动
 */
export const IndicesListSkeleton: React.FC<IndicesListSkeletonProps> = ({
  count = 4,
  className,
}) => {
  return (
    <div
      {...{ [HORIZONTAL_SCROLL_ATTR]: "true" }}
      className={cn(
        // 小屏：横向滚动
        "flex flex-row flex-nowrap gap-5 overflow-x-auto no-scrollbar px-4 min-h-[117px]",
        // 大屏：2x2 网格布局
        "md:grid md:grid-cols-2 md:gap-3 md:px-0 md:min-h-[163px]",
        className,
      )}
    >
      {Array.from({ length: count }, (_, index) => (
        <div
          key={`skeleton-${index}`}
          className="flex flex-col justify-between rounded-2 md:rounded-3 bg-background_solid_neutral_primary p-0 md:p-4 w-full animate-pulse h-[117px] md:h-[163px] min-w-[96px] flex-1 md:flex-none md:min-w-0"
        />
      ))}
    </div>
  );
};
